





import { Component, Vue } from 'vue-property-decorator';
import HeaderComponent from '@/components/Header.vue';
@Component({
  name: 'heading-text-element',
  components: {
    HeaderComponent,
  },
})
export default class HeadingTextElement extends Vue {}
